import Vue from 'vue'
import Router from 'vue-router'

// 登录
import Login from '@/pages/sys/login.vue'   // 登录页

// Home
import Home from '@/pages/home/index.vue'   // Home页

// 运营数据
import DataEffect from '@/pages/home/dataEffect/index.vue'   // 数据效果主页
import DataReport from '@/pages/home/dataEffect/dataReport/index.vue'



Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            children: [
                {
                    path: '/dataEffect',
                    name: 'dataEffect',
                    component: DataEffect,
                    children: [
                        {
                            path: 'dataReport',
                            name: 'dataReport',
                            component: DataReport,
                        }
                    ]
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js